export default "__VITE_ASSET__9eul3ecq__"